export default __webpack_public_path__ + "static/nano_horz_color-4x-23e46f7098524a2a885e15b425419482.jpg";